import { DisplayedRatePlanCode } from './../rate-plan-code/rate-plan-code/displayed-rate-plan-code';
import { EventReservationSource } from './../models/event-reservation-source';
import { List } from 'immutable';
import { PioneerUtils } from './../utils/pioneer-utils';
import { ErrorCode } from '../models/error-code';
import { RatePlanCodeValidationRequest } from './../models/rate-plan-code-validation-request';
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnyxEvent } from '../models/event';
import { BasicEventDataValidator } from './basic-event-data.validator';
import { CustomValidators } from 'ng2-validation';
import { PioneerValidators } from '../../shared/utils/pioneer.validators';
import { DateUtil } from '../../shared/utils/date.util';
import { PropertyLookupStore } from '../../shared/lookup/property-lookup/property-lookup.store';
import { PropertyLookupDetail } from '../../shared/models/property-lookup-detail';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { EventStore } from '../service/event.store';
import { Observable } from 'rxjs/Observable';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { BulkUploadResponse } from '../models/bulk-upload-response';
import { Subscription } from 'rxjs/Subscription';
import { ReservationStore } from '../service/reservation-store';
import { CommonDataStore } from '../service/common-data/common-data.store';
import { Currency } from '../models/common-data/currency';
import { RsvpStore } from '../service/rsvp.store';
import { PaymentStore } from '../service/payment.store';
import { Payment } from '../models/payment';
import { RatePlanCode } from '../models/rate-plan-code';
import { Subscriber } from 'rxjs/Subscriber';
import { ValidationError } from '../models/validation-error';
import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalConfig } from '../../shared/confirmation-modal/confirmation-modal-config';
import { TranslateService } from '@ngx-translate/core';
import { Reservation } from '../models/reservation';
import { DropdownItem } from '../models/dropdown-item';
import { EventStatusInfo } from 'app/shared/models/event-status-info';
import { Subject } from 'rxjs/Subject';
import { takeUntil, tap } from 'rxjs/operators';
import { EventUtils } from '../utils/event-utils';
import { EventValidationService } from '../service/event-validation.service';
import { PaymentStatus } from '../models/payment-status.enum';

@Component({
  selector: 'pioneer-basic-event-data',
  templateUrl: './basic-event-data.component.html',
  styleUrls: ['./basic-event-data.component.css']
})
export class BasicEventDataComponent implements OnInit, OnChanges, OnDestroy {
  @Input('parentForm')
  public parentForm: FormGroup;

  public onyxEvent: OnyxEvent;

  @Input()
  public isReadOnly = true;

  @Input()
  public isNewEvent = false;

  @Input()
  public isAgency = false;

  @Input()
  public isMultiVendorPayments = false;

  @Input()
  public eventMultiVendorStatus;

  @Input()
  public isMultiVendorUserAndEventCreatedByProperty = false;

  @ViewChild('bulkEventFile') bulkEventFileInput: ElementRef;

  @ViewChild(ConfirmationModalComponent) confirmationModal: ConfirmationModalComponent;
  public confirmationModalConfig = new ConfirmationModalConfig();

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  fileExtensions: Array<string>;

  isUploadInProgress: boolean;

  public basicEventDataForm: FormGroup;

  private propertyLookupSubscription: Subscription = new Subscription();

  isEventReferenceNumberEditable = true;

  isMeetingIdEditable = true;

  isRatePlanCodeAdding = false;

  hasPayment = false;

  states$: Observable<DropdownItem[]>;
  public selectedCountry$: Observable<DropdownItem>;
  public selectedState$: Observable<DropdownItem>;
  public isStateRequired = PioneerValidators.isStateRequired;
  showState = true;
  agencyOrSupportUser = false;

  private selectedRatePlanIndex: number;
  private selectedRatePlanCode: string;

  get commonDataStore(): CommonDataStore {
    return this._commonDataStore;
  }

  private get chain() {
    return this.parentForm.get('eventProperty') ? this.parentForm.get('eventProperty').get('chain').value : null;
  }

  private get brand() {
    return this.parentForm.get('eventProperty') ? this.parentForm.get('eventProperty').get('brand').value : null;
  }

  private get propertyId() {
    return this.parentForm.get('eventProperty') ? this.parentForm.get('eventProperty').get('propertyId').value : null;
  }

  public get startDateInput() {
    return this.basicEventDataForm.get('startDate');
  }

  public get endDateInput() {
    return this.basicEventDataForm.get('endDate');
  }

  private duplicateRatePlanCodes: string[];

  public get formattedDuplicateRatePlanCodes(): string {
    return this.duplicateRatePlanCodes ? this.duplicateRatePlanCodes.join(', ') : '';
  }

  @ViewChild('eventNameInputEl')
  eventNameInputEl: ElementRef;

  @Input()
  focusEventNameSubject: Subject<boolean>;

  private _destroy$ = new Subject<boolean>();

  canEditGroupCode$: Observable<boolean>;
  canEditEventDates$: Observable<boolean>;
  canEditEventCurrency$: Observable<boolean>;
  canEditShoulderDates$: Observable<boolean>;

  public selectedCurrency$: Observable<DropdownItem>;

  constructor(private formBuilder: FormBuilder,
              private translateService: TranslateService,
              private propertyLookupStore: PropertyLookupStore,
              private eventStore: EventStore,
              private environment: EnvironmentConfiguration,
              private flashMessagesService: FlashMessagesService,
              private authenticationStore: AuthenticationStore,
              private reservationStore: ReservationStore,
              private rsvpStore: RsvpStore,
              private paymentStore: PaymentStore,
              private _commonDataStore: CommonDataStore,
              private eventValidationService: EventValidationService) {
  }

  private dataToFormGroup(event: OnyxEvent): void {
    let _eventReferenceNumber = this.getGroupCode(event);
    this.commonDataStore.loadStatesFromCountry(event.countryCode).take(1).subscribe();

    if (!this.basicEventDataForm) {

      if (this.isMultiVendor) {
        if (this.authenticationStore.isSupportUser()) {
          this.basicEventDataForm = this.formBuilder.group({
            'name': [EventUtils.getEventName(event, this.authenticationStore.isAgencyUser()), Validators.required],
            'eventId': event.eventId,
            'commissionRoomPercentage': [event.eventProperty.commissionRoomPercentage,
              [PioneerValidators.range(0, 100), PioneerValidators.isInteger]],
            'startDate': [DateUtil.formatDate(this.getStartDate(event)), [Validators.required, PioneerValidators.isDate]],
            'endDate': [DateUtil.formatDate(this.getEndDate(event)), [Validators.required, PioneerValidators.isDate]],
            'eventAgency': this.formBuilder.group({}),
            'eventClient': this.formBuilder.group({}),
            'eventProperty': this.formBuilder.group({}),
            'eventReferenceNumber': [_eventReferenceNumber, [Validators.required, PioneerValidators.isAlphaNumeric]],
            'meetingId': event.eventAgency ? event.eventAgency.eventReferenceNumber : null,
            'currency': [event.currency, Validators.required],
            'currencyName': ['', null],
            'ratePlanCode': [null, CustomValidators.rangeLength([3, 10])],
            'ratePlanCodes': this.formBuilder.array(event.ratePlanCodes),
            'commRetention': event.eventProperty.commRetention,
            'shoulderDatesCommission': [event.shoulderDatesCommission, Validators.required],
            'countryCode': [event.countryCode],
            'countryName': ['', null],
            'state': [event.state],
            'stateName': ['', null],
            'city': [event.city],
            'customFields': this.formBuilder.group({})
          }, {
            validator: Validators.compose([
              BasicEventDataValidator.dateCompare,
              PioneerValidators.countryStateCrossValidator('countryCode', 'state')
            ])
          });
        } else {
          this.basicEventDataForm = this.formBuilder.group({
            'name': [EventUtils.getEventName(event, this.authenticationStore.isAgencyUser()), Validators.required],
            'eventId': event.eventId,
            'commissionRoomPercentage': [event.eventProperty.commissionRoomPercentage,
              [PioneerValidators.range(0, 100), PioneerValidators.isInteger]],
            'startDate': [DateUtil.formatDate(this.getStartDate(event)), [Validators.required, PioneerValidators.isDate]],
            'endDate': [DateUtil.formatDate(this.getEndDate(event)), [Validators.required, PioneerValidators.isDate]],
            'eventAgency': this.formBuilder.group({}),
            'eventClient': this.formBuilder.group({}),
            'eventProperty': this.formBuilder.group({}),
            'eventReferenceNumber': [_eventReferenceNumber, [Validators.required, PioneerValidators.isAlphaNumeric]],
            'currency': [event.currency, Validators.required],
            'currencyName': ['', null],
            'ratePlanCode': [null, CustomValidators.rangeLength([3, 10])],
            'ratePlanCodes': this.formBuilder.array(event.ratePlanCodes),
            'commRetention': event.eventProperty.commRetention,
            'countryCode': [event.countryCode],
            'countryName': ['', null],
            'state': [event.state],
            'stateName': ['', null],
            'city': [event.city],
            'customFields': this.formBuilder.group({})
          }, {
            validator: Validators.compose([
              BasicEventDataValidator.dateCompare,
              PioneerValidators.countryStateCrossValidator('countryCode', 'state')
            ])
          });
        }
      } else {
        this.basicEventDataForm = this.formBuilder.group({
            'name': [EventUtils.getEventName(event, this.authenticationStore.isAgencyUser()), Validators.required],
            'eventId': event.eventId,
            'commissionRoomPercentage': [event.eventProperty.commissionRoomPercentage,
              [Validators.required, PioneerValidators.range(0, 100), PioneerValidators.isInteger]],
            'startDate': [DateUtil.formatDate(this.getStartDate(event)), [Validators.required, PioneerValidators.isDate]],
            'endDate': [DateUtil.formatDate(this.getEndDate(event)), [Validators.required, PioneerValidators.isDate]],
            'eventAgency': this.formBuilder.group({}),
            'eventClient': this.formBuilder.group({}),
            'eventProperty': this.formBuilder.group({}),
            'eventReferenceNumber': [_eventReferenceNumber, [Validators.required, PioneerValidators.isAlphaNumeric]],
            'meetingId': event.eventAgency ? event.eventAgency.eventReferenceNumber : null,
            'currency': [event.currency, Validators.required],
            'currencyName': ['', null],
            'ratePlanCode': [null, CustomValidators.rangeLength([3, 10])],
            'ratePlanCodes': this.formBuilder.array(event.eventProperty.ratePlanCodes),
            'commRetention': [event.eventProperty.commRetention, Validators.required],
            'shoulderDatesCommission': [event.shoulderDatesCommission, Validators.required],
            'countryCode': [event.countryCode],
            'countryName': ['', null],
            'state': [event.state],
            'stateName': ['', null],
            'city': [event.city],
            'customFields': this.formBuilder.group({})
          }, {
            validator: Validators.compose([
              BasicEventDataValidator.dateCompare,
              PioneerValidators.countryStateCrossValidator('countryCode', 'state')
            ])
          }
        );
      }
    } else {

      this.basicEventDataForm.patchValue({
        'name': EventUtils.getEventName(event, this.authenticationStore.isAgencyUser()),
        'eventId': event.eventId,
        'commissionRoomPercentage': event.eventProperty.commissionRoomPercentage,
        'startDate': DateUtil.formatDate(this.getStartDate(event)),
        'endDate': DateUtil.formatDate(this.getEndDate(event)),
        'eventReferenceNumber': _eventReferenceNumber,
        'currency': event.currency,
        'currencyName': ['', null],
        'commRetention': event.eventProperty.commRetention,
        'shoulderDatesCommission': event.shoulderDatesCommission,
        'countryCode': event.countryCode,
        'state': event.state,
        'city': event.city,
        'customFields': this.formBuilder.group({})
      });
    }

    this.selectedCurrency$ = this._commonDataStore.getCurrency(event.currency);
    // Set currencyName form control
    this.selectedCurrency$.subscribe(currency => {
      this.basicEventDataForm.controls['currencyName'].setValue(currency.value);
    });

    this.selectedCountry$ = this.commonDataStore.getCountry(event.countryCode);
    if (event.countryCode) {
      this.selectedState$ = this.commonDataStore.getState(event.countryCode, event.state);
    } else {
      this.selectedState$ = Observable.of(new DropdownItem('', event.state));
    }
  }

  private getGroupCode(event: OnyxEvent) {
    return EventUtils.getEventGroupCode(event, this.authenticationStore.isAgencyUser());
  }

  private getStartDate(event: OnyxEvent) {
    return EventUtils.getEventStartDate(event, this.authenticationStore.isAgencyUser());
  }

  private getEndDate(event: OnyxEvent) {
    return EventUtils.getEventEndDate(event, this.authenticationStore.isAgencyUser());
  }

  get ratePlanCodeInput() {
    return this.basicEventDataForm.get('ratePlanCode');
  }

  get commRetention() {
    return this.basicEventDataForm.get('commRetention');
  }

  get shoulderDatesCommission() {
    return this.basicEventDataForm.get('shoulderDatesCommission');
  }

  get ratePlanCodesApplied() {
    return this.basicEventDataForm.get('ratePlanCodes') as FormArray;
  }

  get displayedRatePlanCodes(): DisplayedRatePlanCode[] {
    const displayedRatePlanCodes = this.ratePlanCodesApplied.value.map((ratePlanCodeObj: RatePlanCode) => {
      return new DisplayedRatePlanCode(ratePlanCodeObj.ratePlanCode, ratePlanCodeObj.canBeDeleted);
    });
    return displayedRatePlanCodes;
  }

  ngOnInit() {
    this.dataToFormGroup(this.onyxEvent);
    this.parentForm.setControl('event', this.basicEventDataForm);
    this.isUploadInProgress = false;
    this.fileExtensions = this.environment.bulkEvents.acceptedFileExtensions;

    if (this.authenticationStore.isSinglePropertyUser()) {
      this.propertyLookupStore.selectedCached
        .take(1)
        .subscribe((details: PropertyLookupDetail) => {
          if (this.isNewEvent && !this.isEventCurrencyManuallyEntered()) {
            this.basicEventDataForm.patchValue({'currency': details.currency});
          }
        });
    }

    // this.commonDataStore.currencies.subscribe(currencies => this.currencies = currencies);

    this.isEventReferenceNumberEditable = true;
    if (!this.isNewEvent && !this.isReadOnly) {
      this.reservationStore.getEventHasReservations().take(1).subscribe(hasReservations => {
        if (hasReservations === true) {
          this.isEventReferenceNumberEditable = false;
        }
      });

      this.paymentStore.payments.take(1).subscribe(paymentList => {
        if (paymentList && paymentList.size > 0) {
          this.hasPayment = true;
          if (this.authenticationStore.isAgencyUser()) {
            this.isEventReferenceNumberEditable = false;
          }
        }
      });

      if (this.authenticationStore.isPropertyUser()) {
        this.paymentStore.getLatestVendorFinalPayments().take(1).subscribe(payments => {
          if (payments && payments.length > 0 && PaymentStatus.REJECTED_WF_APPROVAL !== payments[0].status) {
            this.isEventReferenceNumberEditable = false;
          }
        });
      }

      this.paymentStore.getPrepayment().subscribe((prepayment: Payment) => {
        if (prepayment && prepayment.eventPaymentId) {
          this.isEventReferenceNumberEditable = false;
          this.hasPayment = true;
        }
      });

      if (this.authenticationStore.isSupportUser()) {
        this.isEventReferenceNumberEditable = false;
      }

    }

    this.states$ = this.commonDataStore.states;
    this.states$.subscribe((states) => {
      if (states && states.length > 0) {
        const stateFormControl = this.basicEventDataForm ? this.basicEventDataForm.get('state') : undefined;
        if (stateFormControl) {
          stateFormControl.enable();
        }
      }
    });

    this.setUpCommRetention();
    this.isLocationRequired();
    this.isAgencyUserOrSupportUser();

    if (this.focusEventNameSubject) {
      this.focusEventNameSubject.pipe(
        takeUntil(this._destroy$),
        tap(() => this.eventNameInputEl.nativeElement.focus())
      ).subscribe();
    }

    this.canEditGroupCode$ = this.eventValidationService.canEditGroupCode();
    this.canEditEventDates$ = this.eventValidationService.canEditEventDates();
    this.canEditEventCurrency$ = this.eventValidationService.canEditEventCurrency();
    this.canEditShoulderDates$ = this.eventValidationService.canEditShoulderDates();

  }

  ngOnDestroy() {
    this.propertyLookupSubscription.unsubscribe();
    this._destroy$.next(true);
    this._destroy$.complete();
  }

  onCountryCodeChanged() {
    this.basicEventDataForm.get('state').reset();
    this.states$ = this.commonDataStore.loadStatesFromCountry(this.basicEventDataForm.get('countryCode').value);
    this.states$.take(1).subscribe((states: DropdownItem[]) => {
      this.showState = states.length > 0;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    /*
     * Since we're subscribed to the selectedEvent in the event store,
     * this will detect if something changes (or if loading finishes) and we need to update the form.
     */
    if (!changes['event']) {
      return;
    }

    this.dataToFormGroup(this.onyxEvent);

    this.setUpCommRetention();
  }

  isAutoGenerated(): boolean {
    return this.onyxEvent.autoGenerated;
  }

  isEventCurrencyManuallyEntered(): boolean {
    let currencyControl = this.basicEventDataForm.controls['currency'];
    return currencyControl.touched && currencyControl.dirty;
  }

  handleUploadError(errorMessage: string, logMessage: string = null) {
    this.isUploadInProgress = false;
    this.flashMessagesService.error(errorMessage, logMessage);
  }

  clearFileInput(): void {
    this.bulkEventFileInput.nativeElement.value = null;
  }

  downloadInvalidEventsCsv(fileId: number): void {
    this.eventStore.downloadInvalidEventsCsv(fileId);
  }

  importEventsViaCsv(inputEvent) {
    this.isUploadInProgress = true;
    if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
      this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_EVENTS');
      return;
    }

    const file = inputEvent.srcElement.files[0];
    this.clearFileInput();

    if (this.environment.bulkEvents.acceptedFileTypes.indexOf(file.type) < 0) {
      this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_EVENTS');
      return;
    }
    if (file.size > Math.pow(2, 20)) {
      this.handleUploadError('MESSAGES.ERROR.BULK_UPLOAD_TOO_LARGE');
      return;
    }
    this.eventStore.importEventsViaCsv(file)
      .finally(() => {
        this.isUploadInProgress = false;
      })
      .catch((error => {
        this.showErrorMessage(error);
        return Observable.throw(error);
      }))
      .subscribe((response) => {
        if (response.successful && response.successful > 0) {
          this.showSuccessfulRecordsMessage(response);
        }
        if (response.failed && response.failed > 0) {
          this.showInvalidRecordsMessage(response);
        }
      });
  }

  showErrorMessage(error): void {
    this.flashMessagesService.error('MESSAGES.ERROR.UPLOAD_BULK_EVENTS', `Error uploading bulk events: ${error}`);
  }

  showSuccessfulRecordsMessage(response: BulkUploadResponse): void {
    this.flashMessagesService.success('MESSAGES.SUCCESS.UPLOAD_BULK_EVENTS', null, {eventCount: Number(response.successful)});
  }

  showInvalidRecordsMessage(response: BulkUploadResponse): void {
    this.flashMessagesService.warn('MESSAGES.SUCCESS.UPLOAD_BULK_EVENTS_INVALID', null,

      {
        eventCount: Number(response.failed),
        href: this.environment.baseUrl + '/api/events/bulkUpload/'
          + response.fileId + '?Authorization=' + this.authenticationStore.getToken()
      });
  }

  select(currency: Currency) {
    this.basicEventDataForm.value.currency = currency.code;
  }

  addRatePlanCode() {
    if (this.isValid(this.ratePlanCodeInput)
      && this.isRatePlanCodeAdding === false) {
      this.isRatePlanCodeAdding = true;
      this.isDuplicateRatePlanCode(this.ratePlanCodeInput.value)
        .map((isDuplicate: boolean) => {
          if (!isDuplicate) {
            this.ratePlanCodesApplied.push(this.formBuilder.control(new RatePlanCode({ratePlanCode: this.ratePlanCodeInput.value})));
            this.ratePlanCodeInput.reset();
            this.parentForm.markAsDirty();
          }
        })
        .take(1)
        .subscribe();
      setTimeout(() => {
        this.isRatePlanCodeAdding = false;
      }, 1000);

    }
  }

  confirmBeforeDeletingRatePlanCode(ratePlanCodeIndex: number) {
    if (this.isNewEvent) {
      this.deleteRatePlanCode(ratePlanCodeIndex);
    } else {
      this.selectedRatePlanIndex = ratePlanCodeIndex;
      this.selectedRatePlanCode = this.ratePlanCodesApplied.get([ratePlanCodeIndex]).value.ratePlanCode;
      this.eventStore.getReservationCountForRatePlanCode(this.onyxEvent.eventProperty.eventPartyId, this.selectedRatePlanCode)
        .subscribe(countObject => {
          // set up the title of the confirmation modal
          const titleLabel = 'EVENT.DELETE_RATE_PLAN_CODE';
          this.confirmationModalConfig.title = this.translateService.instant(titleLabel);

          // set up the content of the confirmation modal
          const contentLabel = 'EVENT.DELETE_RATE_PLAN_CODE_CONTENT';
          const params = {
            ratePlanCode: this.selectedRatePlanCode,
            reservationCount: countObject.reservationCount
          };
          this.confirmationModalConfig.content = this.translateService.instant(contentLabel, params);
          this.confirmationModal.open();
        });
    }
  }

  confirmBeforeDeletingRatePlanCodeHandler(proceed: boolean) {
    if (proceed) {
      this.deleteRatePlanCode(this.selectedRatePlanIndex);
    }
  }

  private deleteRatePlanCode(ratePlanIndex: number) {
    this.ratePlanCodesApplied.removeAt(ratePlanIndex);
    this.parentForm.markAsDirty();
  }

  /**
   * Returns true if new Rate Plan Code is valid and not yet in the list
   *
   * @param newRatePlanCode the AbstractControl of the Rate Plan Code
   * @returns true if it is valid; false otherwise
   */
  private isValid(newRatePlanCode: AbstractControl) {
    if (newRatePlanCode.value != null && newRatePlanCode.valid) {
      const filteredList = this.ratePlanCodesApplied.value.filter((ratePlanCode: RatePlanCode) => {
        return ratePlanCode.ratePlanCode === newRatePlanCode.value;
      });

      return filteredList.length === 0;
    }
  }

  /**
   * Called in the (blur) event of the rate plan code input
   * to check if it contains a duplicate rate plan code.
   */
  ratePlanCodeBlur() {
    if (this.ratePlanCodeInput.dirty && this.ratePlanCodeInput.valid) {
      this.ratePlanCodeInput.setValue(PioneerUtils.safeTrim(this.ratePlanCodeInput.value));
      this.checkDuplicateRatePlanCodeInput();
    }
  }

  /*
   * Adds a validation error to the rate plan code input
   * in case it contains a duplicate rate plan code.
   * It removes the error otherwise.
   */
  private checkDuplicateRatePlanCodeInput() {
    if (this.ratePlanCodeInput.value) {
      this.isDuplicateRatePlanCode(this.ratePlanCodeInput.value)
        .map((isDuplicate: boolean) => {
          if (!isDuplicate) {
            // The duplicate error is removed from the input
            this.ratePlanCodeInput.updateValueAndValidity();
          } else if (this.ratePlanCodeInput.valid) {
            // The duplicate error is added to the input if it doesn't have a validation error (the same error or a different one)
            this.ratePlanCodeInput.setErrors({'duplicate_rate_plan_code': true});
          }
        })
        .take(1)
        .subscribe();
    }
  }

  /**
   * Called in the (blur) event of startDate and endDate.
   * It validates rate plan codes to check if there are duplicates:
   * * It checks all the rate plan codes added to the event (this.ratePlanCodesApplied),
   * * it removes the duplication error from the other date input,
   * * and it checks the rate plan code input
   *
   * @param dateInputElement
   */
  datesBlur(dateInputElement: AbstractControl) {
    if (dateInputElement.dirty) {
      if (this.canCheckDuplicateRatePlanCode()) {
        const ratePlanCodes = this.extractAddedRatePlanCodes();
        if (ratePlanCodes.length > 0) {
          this.getRatePlanCodeDuplicationErrors(ratePlanCodes)
            .map((duplicationErrors: ValidationError[]) => {
              // Updates the attribute duplicateRatePlanCodes used to display the list of duplicates in an error message
              this.duplicateRatePlanCodes = duplicationErrors.map((duplicationError) => duplicationError.fieldValue);
              if (this.duplicateRatePlanCodes.length > 0) {
                // Adds the error to the input element producing the (blur) event
                dateInputElement.setErrors({'duplicate_rate_plan_codes_by_date': true});
              }
              // The duplicate error is removed from the other date input
              if (dateInputElement === this.startDateInput) {
                this.endDateInput.updateValueAndValidity();
              } else {
                this.startDateInput.updateValueAndValidity();
              }
            })
            .take(1)
            .subscribe();
        }
      }
      // If a date has changed, the rate plan code input is also checked
      this.checkDuplicateRatePlanCodeInput();
    }
  }

  /**
   * Called in the (change) event of startDate and endDate
   * to avoid displaying both validation errors at the same time
   * (duplication error and end date before start date)
   */
  datesChange() {
    if (this.basicEventDataForm.hasError('greater')) {
      this.endDateInput.updateValueAndValidity();
      this.ratePlanCodeInput.updateValueAndValidity();
    }
  }

  /**
   * Returns true if the rate plan code provided is a duplicate.
   * Returns false otherwise (also in case the preconditions are not fulfilled).
   */
  private isDuplicateRatePlanCode(ratePlanCode: string): Observable<boolean> {

    const obs$: Observable<boolean> = new Observable((observer: Subscriber<boolean>) => {
      if (!!ratePlanCode && ratePlanCode.length > 0 && this.canCheckDuplicateRatePlanCode()) {
        // Removing white spaces
        let rpcNoSpace = ratePlanCode.replace(/\s/g, '');
        if (rpcNoSpace.length > 0) {
          this.getRatePlanCodeDuplicationErrors([ratePlanCode])
            .map((duplicationErrors: ValidationError[]) => {
              const isDuplicate = duplicationErrors.length > 0;
              observer.next(isDuplicate);
            })
            .take(1)
            .subscribe();
        } else {
          observer.next(false);
        }
      } else {
        observer.next(false);
      }
    });

    return obs$;
  }

  /**
   * Returns the duplication errors of an array of rate plan codes.
   *
   * @param ratePlanCodes
   */
  private getRatePlanCodeDuplicationErrors(ratePlanCodes: string[]): Observable<ValidationError[]> {
    const request = new RatePlanCodeValidationRequest({
      eventId: this.onyxEvent.eventId,
      eventPartyId: this.onyxEvent.eventProperty.eventPartyId,
      chain: this.chain,
      brand: this.brand,
      propertyId: this.propertyId,
      ratePlanCodes: ratePlanCodes,
      startDate: this.startDateInput.value,
      endDate: this.endDateInput.value
    });
    return this.eventStore.getRatePlanCodeValidation(request)
      .map(validationErrors =>
        validationErrors.filter(validationError => validationError.errorCode === ErrorCode.DUPLICATE)
      );
  }

  /**
   * Returns true if the preconditions required for checking rate plan code uniqueness are fulfilled,
   * namely startDate and endDate are populated with valid dates, and the event property is selected.
   */
  private canCheckDuplicateRatePlanCode(): boolean {
    const starDateIsValid = DateUtil.isValidDateString(this.startDateInput.value as string);
    const endDateIsValid = DateUtil.isValidDateString(this.endDateInput.value as string);
    const dateRangeIsValid = !this.basicEventDataForm.hasError('greater');
    const propertyIsValid = !!this.propertyId;
    return starDateIsValid && endDateIsValid && dateRangeIsValid && propertyIsValid;
  }

  private extractAddedRatePlanCodes(): string[] {
    return (this.ratePlanCodesApplied.value as RatePlanCode[]).map(ratePlanCode => ratePlanCode.ratePlanCode);
  }

  datesHaveDuplicateRatePlanCodeError() {
    return this.startDateInput.hasError('duplicate_rate_plan_codes_by_date')
      || this.endDateInput.hasError('duplicate_rate_plan_codes_by_date');
  }

  enableCommRetention() {
    this.commRetention.enable();
  }

  disableCommRetention() {
    this.commRetention.disable();
  }

  setUpCommRetention() {
    if (this.isReadOnly || this.hasPayment) {
      this.disableCommRetention();
    } else {
      this.enableCommRetention();
    }
  }

  get isMultiVendor(): boolean {
    return this.authenticationStore.hasPermission('MultiVendor');
  }

  setUpShoulderDates() {
    if (this.isReadOnly || this.hasPayment) {
      this.shoulderDatesCommission.disable();
    } else {
      this.shoulderDatesCommission.enable();
    }
  }

  isLocationRequired() {
    if (this.authenticationStore.isAgencyUser() || this.authenticationStore.isSupportUser()) {
      this.basicEventDataForm.get('countryCode').setValidators(Validators.required);
      this.basicEventDataForm.get('city').setValidators(Validators.required);
      this.basicEventDataForm.updateValueAndValidity();
    }
  }

  isAgencyUserOrSupportUser() {
    if (this.authenticationStore.isAgencyUser() || this.authenticationStore.isSupportUser()) {
      this.agencyOrSupportUser = true;
    }
  }

  public getStatusClasses(status: string): string {

    const eventStatusInfo: EventStatusInfo = new EventStatusInfo(status);

    if (eventStatusInfo.isPaid()) {
      return 'badge-success';
    } else if (eventStatusInfo.isUnpaid()) {
      return 'badge-danger';
    } else if (eventStatusInfo.isProcessing()) {
      return 'badge-warning';
    } else if (eventStatusInfo.isCancelled()) {
      return 'badge-secondary';
    } else {
      return '';
    }

  }

  canSeeShoulderDatesSection() {
    return this.authenticationStore.hasPermission('SingleVendor') || this.authenticationStore.isSupportUser();
  }

  isAgencyUser(): boolean {
    return this.authenticationStore.isAgencyUser();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/basic-event-data/basic-event-data.component.ts